import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import '../../../scss/components/_throbber.scss'

const Throbber = ({color}) => {
  const throbberClasses = classNames('throbber', {
    [`throbber--${color}`]: color,
  })

  return (
    <div className={throbberClasses}>
      <div className="throbber-dot" />
      <div className="throbber-dot" />
      <div className="throbber-dot" />
    </div>
  )
}

Throbber.defaultProps = {
  color: 'default',
}

Throbber.propTypes = {
  color: PropTypes.oneOf(['default', 'dark']),
}

export default Throbber
